export enum BaseUrl {
    Frontend = "frontend_url",
    Base = "baseurl",
    FileUpload = "fileUploadurl",
    NexgenInvoiceBackend = "NexgenInvoiceBackend",
    seamLessPg = "seamLessPg"
}